import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Route, Switch, useHistory, useRouteMatch } from 'react-router-dom'
import { mnoContactListSelector, fetchMnoContactList, updateMnoContact, deleteMnoContact, createMnoContact } from '../../../redux/AdminSlice'
import ContactTable from './ContactTable'
import EditContactPage from './EditContactPage'

export const ContactManagement = () => {
  let contactList = useSelector(mnoContactListSelector)

  const [selectedContact, selectContact] = useState(undefined)

  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(fetchMnoContactList())
  }, [dispatch])

  const match = useRouteMatch()
  const history = useHistory()
  const handleEditClick = (contact) => {
    selectContact(contact)
    history.push(`${match.path}/edit`)
  }

  const editSaveClicked = (contact) => {
    dispatch(updateMnoContact(contact))
    returnToContactList()
  }

  const editDeleteClicked = (contact) => {
    dispatch(deleteMnoContact(contact))
    returnToContactList()
  }

  const returnToContactList = () => {
    selectContact(undefined)
    history.push(match.path)
  }

  const gotoCreateNewContactPage = () => {
    history.push(`${match.path}/create`)
  }

  const newUserSaveClicked = (contact) => {
    dispatch(createMnoContact(contact))
    returnToContactList()
  }
  return (
    <div className="row" style={{ marginBottom:"50px" }}>
      <div className="col-12">
      <Switch>
        <Route path={`${match.path}/edit`}>
          <EditContactPage contact={selectedContact} 
                           onSave={editSaveClicked} 
                           onDelete={editDeleteClicked} 
                           onError={returnToContactList} 
                           onCancel={returnToContactList}/>
        </Route>
        <Route path={`${match.path}/create`}>
          <EditContactPage contact={{}}
                           onSave={newUserSaveClicked} 
                           onError={returnToContactList} 
                           onCancel={returnToContactList}/>
        </Route>
        <Route path={match.path}>
          <div>
            <h2>MNO Contact Management</h2>
            <ContactTable contactList={contactList} onEditClick={handleEditClick}/>
            <button className="float-right btn btn-primary" style={{ marginTop: "1em" }} onClick={gotoCreateNewContactPage}>Create New User</button>
          </div>
        </Route>
      </Switch>
      </div>
    </div>
  )
}